import { defineAsyncComponent, markRaw, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { getCashBackModal } from 'common/lazy-components.js'
import { useAuth } from 'hooks/useAuth.js'
import { useCashBox } from 'hooks/useCashbox.js'
import { useUserAuthStore } from 'stores/user/auth.js'
import { useSystemStore } from 'src/stores/system'

export function useModalQuery(appModal) {
  const route = useRoute()
  const router = useRouter()

  const { getAuth } = storeToRefs(useUserAuthStore())
  const { altW } = storeToRefs(useSystemStore())

  const { login, register } = useAuth()
  const { open: openCashbox } = useCashBox(appModal)

  const AVAILABLE_MODALS_BY_QUERY = {
    login: {
      open: login,
      authRequire: false,
    },
    reg: {
      open: register,
      authRequire: false,
    },
    recovery: {
      open: () => login({ startWithPassRecovery: true }),
      authRequire: false,
    },
    cashbox: {
      open: openCashbox,
      authRequire: true,
    },
    cashback: {
      open: () => {
        if (altW.value) {
          return
        }
        openAppModal(getCashBackModal())
      },
      authRequire: true,
    },
    repeatTopUpModal: {
      open: () => openAppModal(markRaw(defineAsyncComponent(() => import('components/modals/RepeatTopUpModal.vue')))),
      authRequire: true,
    },
  }

  const getModal = (name) => {
    const modal = AVAILABLE_MODALS_BY_QUERY[name]
    if (!modal) {
      return
    }
    if (modal.authRequire && !getAuth.value) {
      return AVAILABLE_MODALS_BY_QUERY.login
    }
    if (modal.authRequire === getAuth.value || modal.authRequire === undefined) {
      return modal
    }
  }

  function openModal(modalName) {
    const modal = getModal(modalName)
    if (modal) {
      modal.open()
    }
  }

  function openAppModal(component, props = {}) {
    appModal.open({ componentName: component, props }).finally(() => router.replace({ query: null }))
  }

  watch(
    () => route.query.modal,
    (newModal, oldModal) => {
      if (newModal && newModal !== oldModal) {
        openModal(newModal)
      }
    },
    { immediate: true },
  )
}
